export type FramePresetType = "custom" | "a4" | "letter" | "16x9" | "4x3" | "1x1" | "phone" | "tablet" | "desktop";

export type AspectRatioPreset = {
  id: FramePresetType;
  displayName: string;
  iconRenderer: () => JSX.Element;
  width?: number;
  height?: number;
};

export const FramePresets: AspectRatioPreset[] = [
  {
    id: "custom",
    displayName: "Custom",
    iconRenderer: renderCustomIcon,
  },
  {
    id: "a4",
    displayName: "A4",
    iconRenderer: renderA4Icon,
    width: 794,
    height: 1123,
  },
  {
    id: "letter",
    displayName: "Letter",
    iconRenderer: renderLetterIcon,
    width: 816,
    height: 1054,
  },
  {
    id: "16x9",
    displayName: "16:9",
    iconRenderer: render16x9Icon,
    width: 1920,
    height: 1080,
  },
  {
    id: "4x3",
    displayName: "4:3",
    iconRenderer: render4x3Icon,
    width: 1440,
    height: 1080,
  },
  {
    id: "1x1",
    displayName: "1:1",
    iconRenderer: render1x1Icon,
    width: 1080,
    height: 1080,
  },
  {
    id: "phone",
    displayName: "Phone",
    iconRenderer: renderPhoneIcon,
    width: 257,
    height: 558,
  },
  {
    id: "tablet",
    displayName: "Tablet",
    iconRenderer: renderTabletIcon,
    width: 800,
    height: 1280,
  },
  {
    id: "desktop",
    displayName: "Desktop",
    iconRenderer: renderDesktopIcon,
    width: 1920,
    height: 1080,
  },
];

export const CimFrameIcons: Record<FramePresetType, any> = {
  custom: "icon-frame-freeform",
  a4: "icon-frame-a4",
  letter: "icon-frame-letter",
  "16x9": "icon-frame-16_9",
  "4x3": "icon-frame-4_3",
  "1x1": "icon-frame-1_1",
  phone: "icon-frame-phone",
  tablet: "icon-frame-tablet",
  desktop: "icon-frame-desktop",
};

function render1x1Icon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="15" height="15" stroke="currentColor" />
    </svg>
  );
}

function render4x3Icon() {
  return (
    <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="18" height="15" stroke="currentColor" />
    </svg>
  );
}

function render16x9Icon() {
  return (
    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="21" height="15" stroke="currentColor" />
    </svg>
  );
}

function renderA4Icon() {
  return (
    <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="13.5" y="0.5" width="18" height="13" transform="rotate(90 13.5 0.5)" stroke="currentColor" />
    </svg>
  );
}

function renderDesktopIcon() {
  return (
    <svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="3" y1="3.5" x2="5" y2="3.5" stroke="currentColor" />
      <line x1="7" y1="3.5" x2="19" y2="3.5" stroke="currentColor" />
      <rect x="21.5" y="14.5" width="21" height="14" transform="rotate(-180 21.5 14.5)" stroke="currentColor" />
    </svg>
  );
}

function renderCustomIcon() {
  return (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1.5" y="1.5" width="21" height="15" stroke="currentColor" />
      <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor" />
      <circle cx="1.5" cy="16.5" r="1.5" fill="currentColor" />
      <circle cx="22.5" cy="1.5" r="1.5" fill="currentColor" />
      <circle cx="22.5" cy="16.5" r="1.5" fill="currentColor" />
    </svg>
  );
}

function renderLetterIcon() {
  return (
    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="15.5" y="0.5" width="21" height="15" transform="rotate(90 15.5 0.5)" stroke="currentColor" />
    </svg>
  );
}

function renderPhoneIcon() {
  return (
    <svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="11.5" y="0.5" width="18" height="11" transform="rotate(90 11.5 0.5)" stroke="currentColor" />
      <line x1="4" y1="2.5" x2="8" y2="2.5" stroke="currentColor" />
    </svg>
  );
}

function renderTabletIcon() {
  return (
    <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="15.5" y="0.5" width="20" height="15" transform="rotate(90 15.5 0.5)" stroke="currentColor" />
      <line x1="7" y1="18.5" x2="9" y2="18.5" stroke="currentColor" />
    </svg>
  );
}
